<div class="header">
  <div class="block">
    <div class="left">
      <app-svg-icon
        [name]="order.type === orderTypes.DELIVERY ? 'kitchen-menu' : 'store'"
        color="color-neutral-1"
        class="icon"
      ></app-svg-icon>
      <div class="text">
        {{
          "@components.orderList.header.date"
            | translate
              : {
                  createdAt: order.createdAt | date : "dd/MM/y"
                }
        }}
      </div>
    </div>
    <div class="right">
      <app-svg-icon name="order"></app-svg-icon>
      <div class="text">{{ order.id }}</div>
    </div>
  </div>
  <div class="block">
    <div class="left">
      <app-svg-icon class="icon" [name]="'wallet'"></app-svg-icon>
      <div class="text">
        {{
          ("@components.orderList.header.paidBy" | translate) +
            " " +
            ("@common.paymentMethods." + order.paymentType | translate)
        }}
      </div>
    </div>
  </div>
</div>
